import React, { createContext, useState, useEffect } from "react";
import MobileMenu from "../components/MobileMenu";
import { useWindowSize } from "../hooks/useWindowResize";

export const MenuMobileContext = createContext({});

export function MenuMobileProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const size = useWindowSize();

  const handleToggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen && size.width <= 768) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "auto";
    }
  }, [isOpen, size.width]);

  return (
    <MenuMobileContext.Provider value={{ handleToggleMenu }}>
      {isOpen && <MobileMenu />}
      {children}
    </MenuMobileContext.Provider>
  );
}
